import { displayCurrencyOptions } from '../../utils/currencyDisplayFormat';

export const currencyDisplayUpdate = (defaultCurrency) => {
    displayCurrencyOptions.currency = defaultCurrency;
};
